/**
 * SPEC-DOCCONSENT-2 — single client-side source of truth for the legal
 * document versions shown on signup.
 *
 * Keep these in sync with the rows seeded in DOCCONSENT-1b's
 * `public.legal_documents` table (is_current = true). The signup metadata
 * the user accepts carries these strings so a later audit can tie the
 * acceptance back to the exact text version. If the constants ever drift
 * from the DB, the signup-trigger falls back to whatever the server has
 * marked `is_current` — but the right discipline is to update both.
 */
export const TERMS_OF_SERVICE_VERSION = "1.0";
export const PRIVACY_NOTICE_VERSION = "2026-05-31";
/**
 * SPEC-DOCCONSENT-3b — version of the in-app disclaimer the
 * DisclaimerGate enforces post-login. Bumping this string forces
 * every existing user to accept again the next time they load the app.
 * Keep in sync with the `disclaimer` row marked `is_current = true` in
 * `public.legal_documents`.
 */
export const DISCLAIMER_VERSION = "1.0";

export type LegalDocType =
  | "terms_of_service"
  | "privacy_notice"
  | "disclaimer";
